import PropTypes from 'prop-types';
import { useState } from 'react';
import { isValidationBasedOnType } from '../../utils/common';

export const VALID_RADIO = 'Please select one option';

const RadioForm = ({ element, handleChange }) => {
  const [showError, setShowError] = useState('');
  const handleRadioClick = (event) => {
    const question = { ...element, userInput: event.target.value, eligibleErr: true };
    if (question.isEligibal) {
      const eligVal = question.eligibleValues.split(',');
      if (eligVal?.includes(question?.userInput)) {
        question.eligibleErr = false;
      }
    }
    if (question.isRequired) {
      if (isValidationBasedOnType(question?.userInput, 'require')) {
        setShowError('');
        question.validationError = false;
      } else {
        setShowError(VALID_RADIO);
        question.validationError = true;
      }
    } else {
      setShowError('');
      question.validationError = false;
    }
    handleChange(event, question);
  };

  return (
    <>
      <div className="d-flex flex-wrap">
        {element?.values.split(',').map((val, index) => (
          <div className="d-flex align-items-center mb-2 me-3" key={`${element._id}-${val}-${index}`}>
            <input
              type="radio"
              className="form-check-input mx-1 fs-13 answer"
              name={element?.question}
              value={val}
              id={val}
              checked={element?.userInput === val}
              onChange={handleRadioClick}
            />
            <label className="form-check-label fs-13 answer mx-1" htmlFor={val}>{val}</label>
          </div>
        ))}
      </div>
      <span className="text-danger fs-12">{showError !== '' && showError}</span>
    </>
  );
};

RadioForm.propTypes = {
  element: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};
export default RadioForm;
